import React from 'react';
import AppContext from 'contexts/AppContext';
import { getMyPermissions } from 'services/permissionServices';

function usePermissions(): { setupPermissions: () => Promise<void> } {
  const { setPermissions } = React.useContext(AppContext);

  const setupPermissions = async () => {
    try {
      const permissions = await getMyPermissions();
      setPermissions(permissions);
    } catch {}
  };

  return { setupPermissions };
}

export default usePermissions;
